import type { AggregateAssetResult } from ".";

export function getDistinctAggregateValues(
  data: AggregateAssetResult[],
  fieldId: string
): string[] {
  return [...new Set(
    data
      .map((item) => item[fieldId])
      .filter((value) => value !== null && value !== undefined && String(value).trim() !== "")
      .map((value) => String(value))
  )].sort();
}

export function countDistinctAggregateValues(
  data: AggregateAssetResult[],
  fieldId: string
): number {
  return getDistinctAggregateValues(data, fieldId).length;
}